import { render, staticRenderFns } from "./InventoryTableBlock.vue?vue&type=template&id=11b1d866&scoped=true"
import script from "./InventoryTableBlock.vue?vue&type=script&lang=js"
export * from "./InventoryTableBlock.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "11b1d866",
  null
  
)

export default component.exports